// Core
import React from "react"
import styled from "styled-components"

// General Components
import BaseContainer from "../../../../components/BaseContainer"

// Components
import CopyContainer from "./components/CopyContainer"
import BankAccounts from "./components/BankAccounts"

// Assets
import Harvest from "../../../../assets/miscellaneous/harvest.jpg"

// Styles

const Section = styled.section`
  background: url(${Harvest}) #000000;
  background-repeat: no-repeat;
  background-size: cover;

  background-position-y: bottom;

  padding: 70px 0;
`

export default function Contribution() {
  return (
    <Section>
      <BaseContainer>
        <CopyContainer />
        <BankAccounts />
      </BaseContainer>
    </Section>
  )
}
